import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { CamelOrderProp } from '@/pages/store-management/master-stores/components/Sidebar/MasterStoreSidebarForm/service';
import {
  ConnectDeliveryService,
  IntegrationStatusNum,
} from '@/pages/store-management/master-stores/service';
import { StoreManagementMasterStoreService } from '@/services/StoreManagement/MasterStores/StoreManagementMasterStoreService';

export type LinkedStatus = 'disabled' | 'enabled';

export type StoreManagementMasterStoreDeliveryStore = {
  id: string;
  external_store_id: string;
  delivery_service_name: ConnectDeliveryService;
  linked_status: LinkedStatus;
  integration_date: Date;
  integration_status: IntegrationStatusNum;
  external_auth_delivery_store: {
    id: number;
    email: string;
    password: string;
    username: string;
  } | null;
  cooking_time: number | null;
  camel_order_prop: CamelOrderProp | null;
  external_store_name: string | null;
};

export type DeliveryArea = {
  name: string;
};

export type StoreManagementMasterStoreShowReqponse = {
  id: number;
  name: string;
  auth_store: {
    id: number;
    name: string;
  };
  brand_name: string;
  linked_status: LinkedStatus;
  has_camel_order_site: boolean;
  business_number: string | null;
  business_name: string | null;
  delivery_stores: StoreManagementMasterStoreDeliveryStore[];
  delivery_areas: DeliveryArea[];
  has_camel_call: boolean;
};

export const useStoreManagementMasterStoreShow = async (
  id: number
): Promise<StoreManagementMasterStoreShowReqponse> => {
  const storeManagementMasterStoreService =
    new StoreManagementMasterStoreService(getClient());
  try {
    return await storeManagementMasterStoreService.show(id);
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
